import { useEffect, useState } from "react";
import useOrganizerPageVisualIdentity from "../../../../shared/hooks/useOrganizerPageVisualIdentity";
import type { OrganizerVisualIdentitySettings } from "../types/auth";
import { getPublicOrganizerVisualIdentity } from "../services/authService";

type LoadedIdentity = {
  organizerUserId: number;
  identity: OrganizerVisualIdentitySettings | null;
};

export default function usePublicOrganizerVisualIdentityTheme(
  organizerUserIdInput?: number | null,
  isOfficial?: boolean,
) {
  const organizerUserId = Number(organizerUserIdInput || 0);
  const enabled =
    isOfficial !== true &&
    Number.isFinite(organizerUserId) &&
    organizerUserId > 0;
  const [loaded, setLoaded] = useState<LoadedIdentity | null>(null);
  const identity =
    enabled && loaded?.organizerUserId === organizerUserId
      ? loaded.identity
      : null;

  useEffect(() => {
    if (!enabled) {
      setLoaded(null);
      return;
    }

    let active = true;
    getPublicOrganizerVisualIdentity(organizerUserId)
      .then((settings) => {
        if (active) setLoaded({ organizerUserId, identity: settings });
      })
      .catch(() => {
        if (active) setLoaded({ organizerUserId, identity: null });
      });
    return () => {
      active = false;
    };
  }, [enabled, organizerUserId]);

  useOrganizerPageVisualIdentity(identity, enabled);

  return identity;
}
